import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { version } from 'config';
import { ApiModel } from './api.model';

@Injectable()
export class UpdatesModel {
    constructor(private apiModel: ApiModel) {}

    public getLatestVersion(): Observable<string> {
        const url = `${this.apiModel.getUpdatesEndpoint()}/version`;
        return this.apiModel.makeHttpObservableRequest({ url, method: 'GET' }).pipe(
            map((response) => response.version),
            catchError((error) => of(version))
        );
    }
}
